import { render, staticRenderFns } from "./professional.vue?vue&type=template&id=bb7ba9be&scoped=true&"
import script from "./professional.vue?vue&type=script&lang=js&"
export * from "./professional.vue?vue&type=script&lang=js&"
import style0 from "./professional.vue?vue&type=style&index=0&id=bb7ba9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7ba9be",
  null
  
)

export default component.exports